var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77778 10.45C6.22222 10.45 5 9.24 5 7.7C5 6.16 6.22222 4.95 7.77778 4.95C9.33333 4.95 10.5556 6.16 10.5556 7.7C10.5556 9.24 9.33333 10.45 7.77778 10.45ZM7.77778 1.0685e-06C3.44444 1.44733e-06 2.98112e-07 3.41 6.73155e-07 7.7C1.17321e-06 13.42 7.77778 22 7.77778 22C7.77778 22 15.5556 13.42 15.5556 7.7C15.5556 3.41 12.1111 6.89669e-07 7.77778 1.0685e-06ZM17.7778 7.7C17.7778 12.65 12.1111 19.47 11.1111 20.68L12.2222 22C12.2222 22 20 13.42 20 7.7C20 4.18 17.6667 1.32 14.4444 0.33C16.4444 2.09 17.7778 4.73 17.7778 7.7Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.d5cf6388fe12cce01a8cea0d111caabf.svg";
export { ForwardRef as ReactComponent };